<template>
  <div :style="(alert.time >= 0)? 'position:fixed; padding: 1px; z-index: 900; min-width: 80%' : ''">
    <v-alert
      :value="alert.ativo"
      :color="alert.msg_type"
      transition="scale-transition">
      {{ alert.msg }}
    </v-alert>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('app', ['animal', 'strings', 'idioma', 'alert'])
  },
  watch: {
    'alert' (val) {
      console.log(val)
      if (val.ativo && this.isTimeOut) setTimeout(() => { this.alert.ativo = false }, this.alert.time)
    }
  }

}
</script>
<style scoped>

</style>
